<template lang="pug">
  .modal(:class="{ active, [size]: true }")
    .modal-overlay(@click="$emit('close')")
    .modal-container
      .modal-header
        a.btn.btn-clear.float-right(@click="$emit('close')")
        .modal-title.h5 {{ title }}
      .modal-body
        .content
          slot(name="modal-body")
      .modal-footer
        slot(name="modal-footer")
</template>

<script>
export default {
  props: {
    active: { type: Boolean, required: true },
    title: { type: String, default: '' },
    modalSize: { type: String, default: 'md' },
  },
  computed: {
    size() {
      return `modal-${this.modalSize}`
    },
  },
  methods: {
    listenEscape({ code }) {
      if (code === 'Escape') this.$emit('close')
    },
  },
  created() {
    document.addEventListener('keydown', this.listenEscape)
  },
  destroyed() {
    document.removeEventListener('keydown', this.listenEscape)
  },
}
</script>
